// @ts-strict-ignore
import React from 'react';
import { DropdownMenu } from '@usealloy/component-library';

interface NodeDropdownItemProps {
  onSelect?(e: Event): void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  disabled: boolean;
  dataId?: string;
}

export default function NodeDropdownItem({
  children,
  onSelect,
  style,
  disabled = false,
  dataId,
}: NodeDropdownItemProps) {
  return (
    <DropdownMenu.Item
      disabled={disabled}
      onSelect={e => {
        e.stopPropagation();
        onSelect(e);
      }}
      onClick={e => e.stopPropagation()}
      style={style}
      data-dd-action-name={dataId}
    >
      {children}
    </DropdownMenu.Item>
  );
}
